import { usePermissions } from '@/entities/session/hooks/usePermissions'
import { PERMISSIONS } from '@/shared/config/permissions'

export type ChatCapabilities = {
  canChat: boolean
  canOps: boolean
  canBroadcast: boolean
  enabled: boolean
}

export function useChatCapabilities(): ChatCapabilities {
  const { hasPermission } = usePermissions()
  const canChat = hasPermission(PERMISSIONS.MessagingChat)
  const canOps = hasPermission(PERMISSIONS.MessagingOps)
  return {
    canChat,
    canOps,
    canBroadcast: hasPermission(PERMISSIONS.MessagingBroadcast),
    enabled: canChat || canOps,
  }
}
